var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "overlay" }, [
      _c("div", { staticClass: "overlay-body" }, [
        _vm.$route.name === "Other"
          ? _c("div", [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "img-style" }, [
                _c("img", {
                  attrs: { src: require("@/assets/アセット 9@2x.png") },
                  on: { click: _vm.close }
                })
              ])
            ])
          : _c("div", [
              _c("p", { staticClass: "overlay-text-style conformation" }, [
                _vm._v("確認画面")
              ]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "margin-top-40" }, [
                _c(
                  "button",
                  { staticClass: "yes", on: { click: _vm.complete } },
                  [_vm._v("はい")]
                ),
                _vm._v(" "),
                _c("button", { staticClass: "no", on: { click: _vm.cancel } }, [
                  _vm._v("いいえ")
                ])
              ]),
              _vm._v(" "),
              _vm._m(2)
            ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "other-text" }, [
      _vm._v("今月の健康度チェック"),
      _c("br"),
      _vm._v("は完了しています。")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "overlay-text-style" }, [
      _vm._v("入力した情報で"),
      _c("br"),
      _vm._v("登録してもいいですか？")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-b" }, [
      _vm._v("※入力した全ての情報は"),
      _c("br"),
      _vm._v("後から変更できます")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cbddb56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cbddb56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShowDialog.vue
// module id = null
// module chunks = 